import React, { useEffect, useState } from "react";
import ContactSection from "../Contact-us/Contact-section";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Popup = () => {
  const [viewPopup, setViewPopup] = useState(false); 
  const location = useLocation();

  const closePopup = () => {
    setViewPopup(false); // Close popup on button click
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setViewPopup(false); // Show popup after 3 seconds
    }, 5000);

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, [location]);

  

  return (
    <>
      {viewPopup && (
        <div
          className="modal show popup"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            zIndex: "1050",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              maxWidth: "600px",
              margin: "0", // Ensure no extra margin is added
              position: "relative",
              zIndex: "1060", // Ensure modal content is above the backdrop
            }}
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title fw-bold">Book your Diwali Gifting now and get early-bird offers!</h5>
                <Button
                  type="button"
                  className="close"
                  onClick={closePopup}
                  aria-label="Close"
                  style={{
                    fontSize: "1.5rem",
                    border: "1px solid black",
                    background: "none",
                    color: "black",
                    padding: "0 10px",
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </Button>
              </div>
              <div className="modal-body">
                <p>Fill in your details & our team will connect with you.</p>
                <ContactSection />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
